import { Component, OnInit, ElementRef, ViewChild, Injectable, OnDestroy } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDragEnd, CdkDragStart } from '@angular/cdk/drag-drop';
import { GraphService } from '../../services/graph.service'
import * as firebase from 'firebase'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DateService } from '../../services/date.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-service',
  animations: [
    trigger('dragDrop', [
      // ...
      state('on', style({
        border: 'solid rgb(228, 106, 153)'
      })),
      state('out', style({
        border: 'dashed rgb(150, 150, 150) '
      })),
      transition('on => out', [
        animate('0.1s')
      ]),
      transition('out => on', [
        animate('0.1s')
      ]),
    ]),
  ],
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss']
})


export class ServiceComponent implements OnInit {

  constructor(private graphService: GraphService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private dateService: DateService) { }
  setGraph
  active: string[] = []
  setDate: boolean = false
  setting=false
  inactive: string[] = []
  right:number = -250
  user = firebase.auth().currentUser.uid;
  ref
  toSave: string
  toSaveInac: string
  Auth
  placeTop: number
  placeLeft: number
  deplacement = false
  initialPosition: any
  position = { ...this.initialPosition };
  offset = { x: 0, y: 0 };
  comp
  droppable = false
  dragging = false
  date_start
  date_end
  @ViewChild('sidebar') inactiveGraph: ElementRef;
  @ViewChild('main') activeGraph: ElementRef;
  @ViewChild('setInactive') selectInac: ElementRef;
  @ViewChild('pos') pos: ElementRef
  type:any[] = []
  source:any[] = [] 
  shopId
  signUpForm: FormGroup;
  isAuth
  admin
  service
  page = "Service"
  compteur:number = 0
  
  ngOnInit() {
    this.setGraph = "hide"
    localStorage.setItem('page', 'Service')
    localStorage.setItem('realTime', '0')
    this.authService.getService().then(() => {
      firebase.auth().onAuthStateChanged(
        (user) => {
          if (user) {
            this.authService.isAdmin().then((name) => {
              this.admin = name
              if (this.admin = true && localStorage.getItem('admin_service') != null) {
                this.service = localStorage.getItem('admin_service');
                this.ref = firebase.database().ref('PageConfig/Service/' + localStorage.getItem('admin_service') + '/Charts')
              } else {
                this.service = localStorage.getItem('service')
                this.ref = firebase.database().ref('PageConfig/Service/' + localStorage.getItem('service') + '/Charts')
              }

            }).then(() => {
              var id = firebase.auth().currentUser.uid;
              var ref = firebase.database().ref("users");
              ref.orderByKey().equalTo(id).on("child_added", (snapshot) => {
                if (snapshot.val().actif == true) {
                  this.isAuth = true;
                }
              });
            }).then(() => {
              this.setView()
              this.dateUpdate()
              this.dateService.changeVar.subscribe(message => this.myVar = message);
            })

          } else {
            this.admin = false;
            this.isAuth = false;
          }
        }
      )
    })

  }

  private _myVar: string = "";

  get myVar(): string {
    return this._myVar;
  }
  set myVar(value: string) {
    if (value !== this._myVar) {
      this._myVar = value;
      this.doSomething();
      this.showLibrary()
    }
  }

  doSomething() {
    this.service = localStorage.getItem('admin_service')
    this.ref = firebase.database().ref('PageConfig/Service/' + localStorage.getItem('admin_service') + '/Charts')
    this.dateUpdate()
    this.setView()
    this.active = []
    this.inactive = []
  }

  ngOnDestroy() {
    clearInterval(this.Auth);
  }

  showLibrary() {
    this.setGraph = localStorage.getItem('settings');
    if (this.setGraph == 'show') {
      this.right = 0
      this.setting =true
    }
    else {
      this.setting =false
      this.right = -25
    }
  }
  placeGraph(e) {

    if (this.deplacement == true && this.droppable == true) {
      this.placeLeft = e.offsetX
      this.placeTop = e.offsetY

      this.ref = 'PageConfig/Profil/'+this.user+'/Charts/'+this.comp;
      //Suppression du dernier caractère qui créait un problème inconnu
      // this.ref = this.ref.slice(0,-1);
      this.ref = firebase.database().ref(this.ref);
    
      firebase.database().ref('PageConfig/Service/' + localStorage.getItem('admin_service') + '/Charts/' + this.comp).update({
        top: this.placeTop + this.offset.y,
        left: this.placeLeft + this.offset.x,
        actif: true,
        height: 200,
        width: 400,
      })
    }

  }
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if (this.droppable == true) {
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        this.comp = event.item.element.nativeElement.innerText

        this.deplacement = true;
        this.toSave = ""
        this.toSaveInac = ""
        this.active.forEach(element => {
          this.toSave += element + '_'
        });
        this.inactive.forEach(element => {
          this.toSaveInac += element + '_'
        })
        this.graphService.saveGraphs(this.toSave, this.toSaveInac, this.page);
        this.setView()
      }


    }
  }

  dragStart($event: CdkDragStart) {
    this.dragging = true
  }
  dragEnd($event: CdkDragEnd) {
    this.dragging = false
  }

  async setView() {
    firebase.database().ref('PageConfig/Service/' + localStorage.getItem('admin_service') + '/Charts').orderByKey().once("value", (snapshot) => {
      this.active = snapshot.val().actifs.split("_")
      this.active = this.active.filter(word => word.length > 1)
      this.inactive = snapshot.val().inactifs.split("_")
      this.inactive = this.inactive.filter(word => word.length > 1)
    }).then(()=>{
      this.inactive.forEach((element) => {
        firebase.database().ref('PageConfig/Service/' + localStorage.getItem('admin_service') + '/Charts/' + element + '/config').orderByKey().once("value", (snapshot) => {
          if(snapshot.val().source != null)
            this.source[element] = snapshot.val().source
          if(snapshot.val().type != null)
            this.type[element] = snapshot.val().type
        })
      });
    })

  }

  intoDrop(e) {
    this.droppable = true
  }
  outDrop(e) {
    this.droppable = false;
  }


  dateUpdate() {
    this.compteur = this.compteur+1
    this.date_start = localStorage.getItem('date_start');
    this.date_end = localStorage.getItem('date_end');
  }
  tt = 0
  myFunction() {
    this.dateService.changeMyVar(' ' + this.tt++); // update variable
  }

  getSource(graph){
    var source = this.source[graph]
      if(source =='GA'){
        return "assets/logo_GA.png";
      }else{
        return 'assets/logo_presta.png';
      }
  }

  getType(graph){
    var type = this.type[graph]
    if(type == 'number'){
      return true
    }
    else{
      return false
    }
  }

}
